module.exports = __webpack_public_path__ + "img/institution_placeholder_default.b08fc121.jpg";